import styled from 'styled-components';

export const FooterStyle = styled.footer`
  height: 70px;
  padding: 20px 40px;
  background-color: hsl(180, 10%, 51%);
  color: #fff;
`;
